export enum EnumTipoExibicao {
    Todos,
    Cardapio,
    Catalogo,
    NaoExibir
}